import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ToastService } from 'src/app/core/services/toast.service';
import { ExportCsvService } from 'src/app/core/services/export-csv.service';

@Component({
  selector: 'app-liste-clients',
  templateUrl: './liste-clients.component.html',
  styleUrls: ['./liste-clients.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListeClientsComponent implements OnInit {

  clients: any[] = [];
  clientsFiltres: any[] = [];
  chargement = true;
  recherche = '';
  filtreActif = '';
  enCoursAction: number | null = null;

  constructor(
    private http: HttpClient,
    private router: Router,
    private toast: ToastService,
    private exportCsv: ExportCsvService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.charger();
  }

  charger(): void {
    this.chargement = true;
    this.http.get<any[]>(`${environment.apiurl}users/role/USER`).subscribe({
      next: (data) => {
        this.clients = data || [];
        this.appliquerFiltres();
        this.chargement = false;
        this.cdr.markForCheck();
      },
      error: () => {
        this.chargement = false;
        this.cdr.markForCheck();
      }
    });
  }

  appliquerFiltres(): void {
    let res = [...this.clients];
    if (this.recherche) {
      const t = this.recherche.toLowerCase();
      res = res.filter(c =>
        (c.nom?.toLowerCase() || '').includes(t) ||
        (c.prenom?.toLowerCase() || '').includes(t) ||
        (c.email?.toLowerCase() || '').includes(t) ||
        (c.contact?.toLowerCase() || '').includes(t) ||
        (c.telephone?.toLowerCase() || '').includes(t)
      );
    }
    if (this.filtreActif === 'actif') res = res.filter(c => c.enabled !== false);
    if (this.filtreActif === 'inactif') res = res.filter(c => c.enabled === false);
    this.clientsFiltres = res;
    this.cdr.markForCheck();
  }

  get total(): number { return this.clients.length; }
  get actifs(): number { return this.clients.filter(c => c.enabled !== false).length; }
  get inactifs(): number { return this.clients.filter(c => c.enabled === false).length; }
  get nouveauxCeMois(): number {
    const debut = new Date(); debut.setDate(1); debut.setHours(0,0,0,0);
    return this.clients.filter(c => c.dateCreation && new Date(c.dateCreation) >= debut).length;
  }

  nomComplet(c: any): string {
    return [c.prenom, c.nom].filter(Boolean).join(' ') || c.username || '—';
  }

  voirDetail(c: any): void {
    this.router.navigate(['/clients', c.id]);
  }

  activer(c: any): void {
    this.enCoursAction = c.id;
    this.http.put(`${environment.apiurl}users/${c.id}/enable`, {}).subscribe({
      next: () => {
        c.enabled = true;
        this.toast.succes(`${this.nomComplet(c)} activé`);
        this.appliquerFiltres();
        this.enCoursAction = null;
        this.cdr.markForCheck();
      },
      error: () => { this.toast.erreur('Erreur lors de l\'activation'); this.enCoursAction = null; this.cdr.markForCheck(); }
    });
  }

  desactiver(c: any): void {
    this.enCoursAction = c.id;
    this.http.put(`${environment.apiurl}users/${c.id}/disable`, {}).subscribe({
      next: () => {
        c.enabled = false;
        this.toast.succes(`${this.nomComplet(c)} désactivé`);
        this.appliquerFiltres();
        this.enCoursAction = null;
        this.cdr.markForCheck();
      },
      error: () => { this.toast.erreur('Erreur lors de la désactivation'); this.enCoursAction = null; this.cdr.markForCheck(); }
    });
  }

  exporterCSV(): void {
    this.exportCsv.exporter('clients', [
      { header: 'Nom', key: '_nom' },
      { header: 'Email', key: 'email' },
      { header: 'Téléphone', key: 'contact' },
      { header: 'Ville', key: 'ville' },
      { header: 'Statut', key: '_statut' },
      { header: 'Date inscription', key: '_dateInscription' },
    ], this.clientsFiltres.map(c => ({
      ...c,
      _nom: this.nomComplet(c),
      _statut: c.enabled !== false ? 'Actif' : 'Inactif',
      _dateInscription: c.dateCreation ? new Date(c.dateCreation).toLocaleDateString('fr-FR') : '—',
    })));
  }

  formaterDate(d: string): string {
    if (!d) return '—';
    return new Date(d).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }
}
